var map = {
	"./afghanistan.svg": 73629,
	"./albania.svg": 41607,
	"./algeria.svg": 15858,
	"./andorra.svg": 29552,
	"./angola.svg": 52183,
	"./argentina.svg": 44440,
	"./armenia.svg": 67998,
	"./australia.svg": 40177,
	"./austria.svg": 90974,
	"./azerbaijan.svg": 95506,
	"./bahrain.svg": 76664,
	"./bangladesh.svg": 84430,
	"./belarus.svg": 57727,
	"./belgium.svg": 26016,
	"./belize.svg": 58052,
	"./benin.svg": 77321,
	"./bhutan.svg": 99725,
	"./bolivia.svg": 45315,
	"./bosniaAndHerzegovina.svg": 16212,
	"./botswana.svg": 25124,
	"./brazil.svg": 94379,
	"./brunei.svg": 79018,
	"./bulgaria.svg": 58410,
	"./burkinaFaso.svg": 62058,
	"./burundi.svg": 89572,
	"./cambodia.svg": 31815,
	"./cameroon.svg": 70045,
	"./canada.svg": 13827,
	"./capeVerde.svg": 24042,
	"./centralAfricanRepublic.svg": 15396,
	"./chad.svg": 62807,
	"./chile.svg": 15384,
	"./china.svg": 68846,
	"./colombia.svg": 87119,
	"./costaRica.svg": 42168,
	"./croatia.svg": 52348,
	"./cuba.svg": 73102,
	"./cyprus.svg": 64063,
	"./cz.svg": 62842,
	"./denmark.svg": 95409,
	"./djibouti.svg": 32847,
	"./drc.svg": 66094,
	"./eastTimor.svg": 43759,
	"./ecuador.svg": 10698,
	"./egypt.svg": 69362,
	"./elSalvador.svg": 96100,
	"./equatorialGuinea.svg": 60017,
	"./eritrea.svg": 84905,
	"./estonia.svg": 47610,
	"./ethiopia.svg": 3800,
	"./fiji.svg": 92305,
	"./finland.svg": 1019,
	"./france.svg": 25872,
	"./gabon.svg": 72662,
	"./gambia.svg": 73166,
	"./gb.svg": 55350,
	"./georgia.svg": 75163,
	"./germany.svg": 23284,
	"./ghana.svg": 34874,
	"./gibraltar.svg": 87691,
	"./greece.svg": 68412,
	"./greenland.svg": 87737,
	"./guatemala.svg": 55672,
	"./guinea.svg": 6606,
	"./guineaBissau.svg": 96781,
	"./guyana.svg": 12000,
	"./haiti.svg": 21612,
	"./honduras.svg": 16297,
	"./hongKong.svg": 94848,
	"./hungary.svg": 56557,
	"./iceland.svg": 13189,
	"./india.svg": 85814,
	"./indonesia.svg": 86017,
	"./iran.svg": 1489,
	"./iraq.svg": 32214,
	"./ireland.svg": 14874,
	"./israel.svg": 72001,
	"./italy.svg": 38954,
	"./ivoryCoast.svg": 52134,
	"./japan.svg": 18391,
	"./jordan.svg": 40967,
	"./kazakhstan.svg": 94439,
	"./kenya.svg": 96799,
	"./kiribati.svg": 50760,
	"./kosovo.svg": 7188,
	"./kuwait.svg": 13722,
	"./kyrgyzstan.svg": 32661,
	"./laos.svg": 44322,
	"./latvia.svg": 18880,
	"./lebanon.svg": 88724,
	"./lesotho.svg": 60265,
	"./liberia.svg": 64053,
	"./libya.svg": 2296,
	"./liechtenstein.svg": 99540,
	"./lithuania.svg": 35670,
	"./luxembourg.svg": 51661,
	"./macau.svg": 49200,
	"./macedonia.svg": 53168,
	"./madagascar.svg": 59201,
	"./malawi.svg": 83105,
	"./malaysia.svg": 99460,
	"./maldives.svg": 94814,
	"./mali.svg": 53814,
	"./malta.svg": 43720,
	"./marshallIsland.svg": 520,
	"./mauritania.svg": 25726,
	"./mauritius.svg": 12070,
	"./mexico.svg": 20516,
	"./micronesia.svg": 17609,
	"./moldova.svg": 37003,
	"./monaco.svg": 12320,
	"./mongolia.svg": 41491,
	"./montenegro.svg": 89659,
	"./morocco.svg": 79401,
	"./mozambique.svg": 48459,
	"./myanmar.svg": 73886,
	"./namibia.svg": 4744,
	"./nepal.svg": 70333,
	"./netherlands.svg": 4047,
	"./newZealand.svg": 94368,
	"./nicaragua.svg": 75694,
	"./niger.svg": 17324,
	"./nigeria.svg": 62134,
	"./northKorea.svg": 66980,
	"./norway.svg": 42591,
	"./oman.svg": 896,
	"./pakistan.svg": 20260,
	"./palau.svg": 73730,
	"./palestine.svg": 37542,
	"./panama.svg": 62341,
	"./papuaNewGuinea.svg": 70163,
	"./paraguay.svg": 52089,
	"./peru.svg": 94687,
	"./philippines.svg": 54530,
	"./poland.svg": 45001,
	"./portugal.svg": 95187,
	"./qatar.svg": 65788,
	"./romania.svg": 63066,
	"./rpc.svg": 90378,
	"./russia.svg": 77114,
	"./rwanda.svg": 43972,
	"./samoa.svg": 19622,
	"./sanMarino.svg": 44297,
	"./saoTomeAndPrince.svg": 98547,
	"./saudiArabia.svg": 59149,
	"./senegal.svg": 4750,
	"./serbia.svg": 88163,
	"./seychelles.svg": 51504,
	"./sierraLeone.svg": 97414,
	"./singapore.svg": 96773,
	"./slovakia.svg": 73549,
	"./slovenia.svg": 29160,
	"./solomonIslands.svg": 59936,
	"./somalia.svg": 69621,
	"./southAfrica.svg": 4182,
	"./southKorea.svg": 78938,
	"./southSudan.svg": 98169,
	"./spain.svg": 752,
	"./sriLanka.svg": 14760,
	"./sudan.svg": 6774,
	"./suriname.svg": 37867,
	"./swaziland.svg": 27104,
	"./sweden.svg": 51805,
	"./switzerland.svg": 65400,
	"./syria.svg": 42847,
	"./taiwan.svg": 23933,
	"./tajikistan.svg": 44268,
	"./tanzania.svg": 71703,
	"./thailand.svg": 28880,
	"./togo.svg": 84636,
	"./tonga.svg": 21916,
	"./tunisia.svg": 92172,
	"./turkey.svg": 30551,
	"./turkmenistan.svg": 36064,
	"./tuvalu.svg": 86458,
	"./uae.svg": 14020,
	"./uganda.svg": 41625,
	"./ukraine.svg": 78124,
	"./uruguay.svg": 73115,
	"./us.svg": 96977,
	"./uzbekistan.svg": 66767,
	"./vanuatu.svg": 39051,
	"./venezuela.svg": 22577,
	"./vietnam.svg": 48183,
	"./yemen.svg": 70882,
	"./zambia.svg": 93513,
	"./zimbabwe.svg": 21174
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40333;